const map = {
	"./application_element/element.js": 5081,
	"./attachment/element.js": 57033,
	"./card/element.js": 3192,
	"./card_header/element.js": 74690,
	"./card_like/element.js": 28724,
	"src/web_components/components/application_element/element.js": 5081,
	"src/web_components/components/attachment/element.js": 57033,
	"src/web_components/components/card/element.js": 3192,
	"src/web_components/components/card_header/element.js": 74690,
	"src/web_components/components/card_like/element.js": 28724
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10515;